import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import i18n from './i18n'
import router from './router'

// Font Awesome配置
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faUtensils,
  faShoppingBag,
  faBox,
  faCoffee,
  faPlay,
  faMapMarkerAlt,
  faPhone,
  faEnvelope
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faTiktok
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUtensils,
  faShoppingBag,
  faBox,
  faCoffee,
  faPlay,
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faFacebookF,
  faInstagram,
  faTwitter,
  faTiktok
)

// 创建应用
const app = createApp(App)

// 确保在应用挂载前设置语言
try {
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && i18n.global.availableLocales.includes(savedLocale)) {
    i18n.global.locale.value = savedLocale
  }

  console.log('可用语言:', i18n.global.availableLocales)
  console.log('当前语言:', i18n.global.locale.value)
  console.log('语言消息:', i18n.global.messages.value)
} catch (e) {
  console.error('设置语言失败:', e)
}

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(Antd)
app.use(router)
app.use(i18n)
app.mount('#app')
